import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { MuscleGroupService } from 'src/services/muscle-group.service';

@Pipe({
    name: 'groupColor',
    pure: false,
    standalone: false
})
export class GroupColorPipe implements PipeTransform {
  constructor(private muscleGroupService: MuscleGroupService) {}

  transform(muscleName: string): Observable<string> {
    if (!muscleName) {
      return new Observable((observer) => observer.next('white')); // Provide a default color or handle as needed
    }
    return this.muscleGroupService.getColorByMuscle(muscleName);
  }
}
